// import React, { useEffect } from "react";
// import Logo from "../../components/common/Logo";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { sentOtp } from "../../lib/forgetPassword";
// import { useState } from "react";
// import { loginWithOtp, getStudentDetails } from "../../lib/AuthApi";
// import { useAuth } from "../../context/AuthProvider";
// import { getSubscriptions } from "../../lib/Subscription"

// const LoginWithOtp = () => {
//   const [email, setEmail] = useState("");
//   const [otp, setOtp] = useState(Array(6).fill(""));
//   const [showOtp, setShowOtp] = useState(false);
//   const [timer, setTimer] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const { setUserData } = useAuth();
//   const [error, setError] = useState("");
//   const navigate = useNavigate();
//   const isValidEmail = (email) => {
//     return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
//   };

//   // 🔹 SEND OTP API
//   const handleSendOtp = async () => {
//     const trimmedEmail = email.trim();

//     // ✅ 1. Empty email
//     if (!trimmedEmail) {
//       toast.error("Email is required");
//       return;
//     }

//     // ✅ 2. Invalid email
//     if (!isValidEmail(trimmedEmail)) {
//       toast.error("Enter a valid email address");
//       return;
//     }

//     try {
//       setLoading(true);

//       const res = await sentOtp(trimmedEmail, "LOGIN");
//       // ✅ 3. API success
//       if (res?.success) {
//         setShowOtp(true);
//         setTimer(20); // better UX than 20
//         toast.success(res?.message || "OTP sent successfully");
//       } else {
//         toast.error(res?.message || "Failed to send OTP");
//       }

//     } catch (err) {
//       console.error(err);
//       toast.error("Unable to send OTP. Please enter a valid email.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResendOtp = async () => {
//     const trimmedEmail = email.trim();

//     if (!trimmedEmail) {
//       toast.error("Email is required");
//       return;
//     }

//     if (!isValidEmail(trimmedEmail)) {
//       toast.error("Enter a valid email address");
//       return;
//     }

//     // Clear OTP immediately
//     setOtp(Array(6).fill(""));

//     // Start timer immediately
//     setTimer(30);

//     try {
//       // Call API in background
//       const res = await sentOtp(trimmedEmail, "LOGIN");

//       if (res?.success) {
//         toast.success("OTP resent successfully");
//       } else {
//         toast.error(res?.message || "Failed to resend OTP");
//       }

//     } catch (err) {
//       console.error(err);
//       toast.error("Unable to resend OTP");
//     }
//   };

//   const handleLogin = async (enteredOtp) => {
//     if (!email.trim() || !enteredOtp) {
//       setError("Email and OTP required");
//       return;
//     }

//     try {
//       setLoading(true);
//       setError("");

//       const res = await loginWithOtp({
//         username: email,
//         otp: enteredOtp,
//       });

//       console.log("Login Response:", res);

//       // Check success
//       if (!res?.data?.isSuccess) {
//         toast.error(res?.data?.displayMessage || "Login failed");
//         return;
//       }
//       const result = res.data.result;

//       // Match EXACT API response
//       const basicUser = {
//         token: result.token,
//         userID: result.userID,
//         uuid: result.uuid,
//         sessionId: result.sessionId,
//         role: result.roleName,
//       };

//       // Save basic user
//       localStorage.setItem("user", JSON.stringify(basicUser));
//       setUserData(basicUser);

//       // ================= STUDENT DETAILS =================
//       const studentRes = await getStudentDetails();
//       const studentData = studentRes?.data?.[0] || {};

//       let finalUserData = {
//         ...basicUser,
//         ...studentData,
//       };

//       // ================= SUBSCRIPTION =================
//       const subRes = await getSubscriptions(finalUserData.uuid);

//       finalUserData = {
//         ...finalUserData,
//         hasSubscription: subRes?.success || false,
//         subscriptionData: subRes?.data || null,
//       };

//       // ✅ Save final user
//       localStorage.setItem("user", JSON.stringify(finalUserData));
//       setUserData(finalUserData);

//       // ✅ Redirect
//       if (subRes?.success) {
//         navigate("/live-classes");
//       } else {
//         navigate("/subscription");
//       }

//     } catch (err) {
//       console.error(err);
//       toast.error(
//         err.displayMessage || "Invalid OTP"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleOtpChange = (value, index) => {
//     if (!/^[0-9]?$/.test(value)) return;

//     const newOtp = [...otp];
//     newOtp[index] = value;

//     setOtp(newOtp);

//     // move to next input
//     if (value && index < 5) {
//       document.getElementById(`otp-${index + 1}`).focus();
//     }

//     // auto submit when full
//     if (newOtp.every((digit) => digit !== "")) {
//       handleLogin(newOtp.join(""));
//     }
//   };

//   useEffect(() => {
//     if (timer <= 0) return;

//     const interval = setInterval(() => {
//       setTimer((prev) => prev - 1);
//     }, 1000);

//     return () => clearInterval(interval);
//   }, [timer]);

//   const handleKeyDown = (e, index) => {
//     if (e.key === "Backspace" && !otp[index] && index > 0) {
//       document.getElementById(`otp-${index - 1}`).focus();
//     }
//   };
//   return (
//     <>
//       <title>Login With OTP | InstaED</title>

//       <main className="h-screen flex items-center justify-center bg-secondary font-sans relative">

//         {/* LOGO */}
//         <div className="absolute top-5 left-4">
//           <Logo />
//         </div>

//         {/* MAIN WRAPPER */}
//         <div className="w-full max-w-md flex items-center justify-center px-6 mx-auto">

//           {/* LEFT SIDE - MOBILE OTP */}
//           {/* <div className="w-1/2 flex flex-col items-center text-center pr-10">

//             <h2 className="text-lg font-semibold mb-6">
//               Login via Mobile OTP
//             </h2>

//             <input
//               type="text"
//               placeholder="Enter registered mobile number"
//               className="w-full h-[50px] px-4 rounded-lg border border-gray-border bg-white placeholder:text-gray-light outline-none mb-6"
//             /> */}

//           {/* OTP BOXES */}
//           {/* <div className="flex gap-3 mb-6">
//               {[1, 2, 3, 4].map((_, i) => (
//                 <input
//                   key={i}
//                   maxLength={1}
//                   className="w-[45px] h-[45px] text-center rounded-lg border border-gray-border bg-white outline-none"
//                 />
//               ))}
//             </div> */}

//           {/* <p className="text-sm mb-4">
//               OTP has been sent to your registered <br />
//               mobile number
//             </p>

//             <p className="text-sm">
//               Not received?{" "}
//               <span className="underline cursor-pointer">
//                 Resend
//               </span>{" "}
//               in: 20 sec
//             </p>
//           </div> */}

//           {/* CENTER DIVIDER */}
//           {/* <div className="flex flex-col items-center justify-center">
//             <div className="w-[1px] h-[260px] bg-gray-border"></div>
//             <span className="absolute bg-secondary px-3 text-sm">or</span>
//           </div> */}

//           {/* RIGHT SIDE - EMAIL OTP */}
//           <div className="w-full flex flex-col items-center text-center">

//             <h2 className="text-lg font-semibold mb-6">
//               Login via Email OTP
//             </h2>

//             {!showOtp && (
//               <>
//                 <input
//                   type="text"
//                   placeholder="Enter registered email ID"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter") {
//                       e.preventDefault();
//                       handleSendOtp();
//                     }
//                   }}
//                   className="input"
//                 />
//                 <div className="flex justify-center mt-4 bg-black-600 text-white px-6 py-2 rounded-lg">
//                   <button onClick={handleSendOtp} className="btn">
//                     {loading ? "Sending..." : "Send OTP"}
//                   </button>
//                 </div>
//               </>
//             )}
//             {showOtp && (
//               <>
//                 <div className="flex gap-3 mb-6">
//                   {[...Array(6)].map((_, i) => (
//                     <input
//                       key={i}
//                       id={`otp-${i}`}
//                       maxLength={1}
//                       value={otp[i]}
//                       onChange={(e) => handleOtpChange(e.target.value, i)}
//                       onKeyDown={(e) => handleKeyDown(e, i)}
//                       className="w-[45px] h-[45px] text-center rounded-lg border"
//                     />
//                   ))}
//                 </div>

//                 <p className="text-sm mb-4">
//                   OTP has been sent to your registered <br />
//                   email ID
//                 </p>

//                 <p className="text-sm">
//                   Not received?{" "}
//                   <span
//                     className={`underline ${timer !== 0 ? "opacity-50 cursor-not-allowed" : "cursor-pointer"
//                       }`}
//                     onClick={() => {
//                       if (timer === 0) handleResendOtp();
//                     }}
//                   >
//                     Resend
//                   </span>{" "}
//                   in: {timer} sec
//                 </p>
//               </>
//             )}
//           </div>
//         </div>

//         {/* FOOTER */}
//         <footer className="absolute bottom-4 text-sm text-gray-border">
//           <span>2026</span>
//           <span className="mx-3">|</span>
//           <button className="hover:opacity-70">
//             Terms of Use
//           </button>
//           <span className="mx-3">|</span>
//           <button className="hover:opacity-70">
//             Privacy Policy
//           </button>
//         </footer>

//       </main>
//     </>
//   );
// };

// export default LoginWithOtp;


import React, { useEffect, useRef, useState } from "react";
import Logo from "../../components/common/Logo";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { sentOtp } from "../../lib/forgetPassword";
import {
  loginWithOtp,
  getStudentDetails,
} from "../../lib/AuthApi";
import { useAuth } from "../../context/AuthProvider";
import { getSubscriptions } from "../../lib/Subscription";

const LoginWithOtp = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));
  const [showOtp, setShowOtp] = useState(false);
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { setUserData } = useAuth();
  const navigate = useNavigate();

  const otpRefs = useRef([]);

  // =========================================================
  // EMAIL VALIDATION
  // =========================================================

  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  // =========================================================
  // SEND OTP
  // =========================================================

  const handleSendOtp = async () => {
    const trimmedEmail = email.trim();

    setError("");

    if (!trimmedEmail) {
      toast.error("Email is required");
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      toast.error("Enter a valid email address");
      return;
    }

    try {
      setLoading(true);

      const res = await sentOtp(
        trimmedEmail,
        "LOGIN"
      );

      if (res?.success) {
        setShowOtp(true);
        setOtp(Array(6).fill(""));
        setTimer(30);

        toast.success(
          res?.message || "OTP sent successfully"
        );

        setTimeout(() => {
          otpRefs.current?.[0]?.focus();
        }, 100);
      } else {
        toast.error(
          res?.message || "Failed to send OTP"
        );
      }
    } catch (err) {
      console.error(err);

      toast.error(
        "Unable to send OTP. Please enter a valid email."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // RESEND OTP
  // =========================================================

  const handleResendOtp = async () => {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      toast.error("Email is required");
      return;
    }

    if (!isValidEmail(trimmedEmail)) {
      toast.error("Enter a valid email address");
      return;
    }

    setOtp(Array(6).fill(""));
    setTimer(30);

    try {
      const res = await sentOtp(
        trimmedEmail,
        "LOGIN"
      );

      if (res?.success) {
        toast.success("OTP resent successfully");

        setTimeout(() => {
          otpRefs.current?.[0]?.focus();
        }, 100);
      } else {
        toast.error(
          res?.message || "Failed to resend OTP"
        );
      }
    } catch (err) {
      console.error(err);

      toast.error("Unable to resend OTP");
    }
  };

  // =========================================================
  // LOGIN WITH OTP
  // =========================================================

  const handleLogin = async (enteredOtp) => {
    if (!email.trim() || !enteredOtp) {
      setError("Email and OTP are required");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const res = await loginWithOtp({
        username: email,
        otp: enteredOtp,
      });

      console.log("Login Response:", res);

      if (!res?.data?.isSuccess) {
        toast.error(
          res?.data?.displayMessage || "Login failed"
        );
        return;
      }

      const result = res.data.result;

      // =====================================================
      // BASIC USER
      // =====================================================

      const basicUser = {
        token: result.token,
        userID: result.userID,
        uuid: result.uuid,
        sessionId: result.sessionId,
        role: result.roleName,
      };

      localStorage.setItem(
        "user",
        JSON.stringify(basicUser)
      );

      setUserData(basicUser);

      // =====================================================
      // STUDENT DETAILS
      // =====================================================

      const studentRes = await getStudentDetails();

      const studentData =
        studentRes?.data?.[0] || {};

      let finalUserData = {
        ...basicUser,
        ...studentData,
      };

      // =====================================================
      // SUBSCRIPTION
      // =====================================================

      const subRes = await getSubscriptions(
        finalUserData.uuid
      );

      finalUserData = {
        ...finalUserData,
        hasSubscription:
          subRes?.success || false,
        subscriptionData:
          subRes?.data || null,
      };

      // =====================================================
      // SAVE FINAL USER
      // =====================================================

      localStorage.setItem(
        "user",
        JSON.stringify(finalUserData)
      );

      setUserData(finalUserData);

      // =====================================================
      // REDIRECT
      // =====================================================

      if (subRes?.success) {
        navigate("/live-classes");
      } else {
        navigate("/subscription");
      }
    } catch (err) {
      console.error(err);

      toast.error(
        err?.displayMessage || "Invalid OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================================
  // OTP CHANGE
  // =========================================================

  const handleOtpChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) {
      return;
    }

    const newOtp = [...otp];

    newOtp[index] = value;

    setOtp(newOtp);
    setError("");

    if (value && index < 5) {
      otpRefs.current?.[index + 1]?.focus();
    }

    if (
      newOtp.every(
        (digit) => digit !== ""
      )
    ) {
      handleLogin(newOtp.join(""));
    }
  };

  // =========================================================
  // OTP KEYBOARD
  // =========================================================

  const handleKeyDown = (event, index) => {
    if (
      event.key === "Backspace" &&
      !otp[index] &&
      index > 0
    ) {
      otpRefs.current?.[index - 1]?.focus();
    }

    if (
      event.key === "ArrowLeft" &&
      index > 0
    ) {
      otpRefs.current?.[index - 1]?.focus();
    }

    if (
      event.key === "ArrowRight" &&
      index < 5
    ) {
      otpRefs.current?.[index + 1]?.focus();
    }
  };

  // =========================================================
  // OTP PASTE
  // =========================================================

  const handleOtpPaste = (event) => {
    event.preventDefault();

    const pastedValue = event.clipboardData
      .getData("text")
      .replace(/\D/g, "")
      .slice(0, 6);

    if (!pastedValue) {
      return;
    }

    const newOtp = Array(6).fill("");

    pastedValue.split("").forEach(
      (digit, index) => {
        newOtp[index] = digit;
      }
    );

    setOtp(newOtp);

    if (pastedValue.length === 6) {
      handleLogin(pastedValue);
    } else {
      otpRefs.current?.[
        pastedValue.length
      ]?.focus();
    }
  };

  // =========================================================
  // TIMER
  // =========================================================

  useEffect(() => {
    if (timer <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setTimer(
        (previous) => previous - 1
      );
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  // =========================================================
  // CHANGE EMAIL
  // =========================================================

  const handleChangeEmail = () => {
    setShowOtp(false);
    setOtp(Array(6).fill(""));
    setTimer(0);
    setError("");
  };

  // =========================================================
  // UI
  // =========================================================

  return (
    <>
      <title>Login With OTP | InstaED</title>

      <main className="min-h-screen min-h-[100dvh] bg-[#F7F3EA] flex flex-col overflow-x-hidden">

        {/* =====================================================
            HEADER
        ===================================================== */}

        <header className="w-full">
          <div className="w-full max-w-[1280px] mx-auto px-4 xs:px-5 sm:px-7 md:px-8 lg:px-10 py-4 sm:py-5 md:py-6">

            <div className="w-fit cursor-pointer">
              <Logo />
            </div>

          </div>
        </header>

        {/* =====================================================
            MAIN
        ===================================================== */}

        <section className="flex-1 w-full flex items-center justify-center px-4 xs:px-5 sm:px-7 md:px-8 lg:px-10 py-5 sm:py-7 md:py-9">

          <div className="
            w-full
            max-w-[1120px]
            grid
            grid-cols-1
            md:grid-cols-[0.9fr_1.1fr]
            lg:grid-cols-[1fr_430px]
            gap-6
            md:gap-8
            lg:gap-14
            items-center
          ">

            {/* =================================================
                LEFT INFORMATION
            ================================================= */}

            <div className="w-full">

              <div className="w-full max-w-[600px] mx-auto lg:mx-0">

                {/* BADGE */}

                <div className="inline-flex items-center gap-2 bg-white border border-[#E2D9CA] rounded-full px-3 sm:px-4 py-1.5 sm:py-2 mb-4 sm:mb-5">

                  <span className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-[#4035C9]" />

                  <span className="text-[9px] sm:text-[10px] md:text-[11px] font-semibold tracking-[0.08em] text-[#625C7D]">
                    SECURE LOGIN
                  </span>

                </div>

                {/* TITLE */}

                <h1 className="
                  text-[28px]
                  xs:text-[30px]
                  sm:text-[35px]
                  md:text-[38px]
                  lg:text-[48px]
                  xl:text-[50px]
                  leading-[1.08]
                  font-bold
                  text-[#17144B]
                ">
                  Login
                  <br className="hidden xs:block" />
                  <span className="xs:hidden">
                    {" "}
                  </span>
                  with Email OTP
                </h1>

                {/* DESCRIPTION */}

                <p className="
                  mt-3
                  sm:mt-4
                  max-w-[520px]
                  text-[11px]
                  sm:text-[12px]
                  md:text-[13px]
                  lg:text-[14px]
                  leading-5
                  sm:leading-6
                  text-[#716B82]
                ">
                  Access your InstaED classroom
                  securely using a one-time password
                  sent to your registered email address.
                </p>

                {/* FEATURES */}

                <div className="
                  mt-5
                  sm:mt-6
                  md:mt-7
                  flex
                  flex-col
                  gap-2.5
                  sm:gap-3
                  md:gap-3.5
                ">

                  <Feature
                    number="01"
                    title="Enter your registered email"
                    text="Use the email connected to your InstaED account."
                  />

                  <Feature
                    number="02"
                    title="Verify your OTP"
                    text="Enter the six-digit code sent to your email."
                  />

                  <Feature
                    number="03"
                    title="Continue learning"
                    text="You will be redirected to your InstaED dashboard."
                  />

                </div>

              </div>

            </div>

            {/* =================================================
                LOGIN CARD
            ================================================= */}

            <div className="w-full max-w-[520px] md:max-w-none mx-auto">

              <div className="
                w-full
                bg-white
                border
                border-[#E4DCCF]
                rounded-[18px]
                sm:rounded-[20px]
                md:rounded-[22px]
                shadow-[0_10px_40px_rgba(37,29,82,0.08)]
                overflow-hidden
              ">

                {/* CARD HEADER */}

                <div className="
                  bg-[#4035C9]
                  px-5
                  xs:px-6
                  sm:px-7
                  md:px-8
                  py-5
                  sm:py-6
                  md:py-7
                ">

                  <div className="flex items-center justify-between gap-3">

                    <div className="min-w-0">

                      <p className="
                        text-white/70
                        text-[8px]
                        xs:text-[9px]
                        sm:text-[10px]
                        font-semibold
                        tracking-[0.14em]
                        uppercase
                      ">
                        InstaED Account
                      </p>

                      <h2 className="
                        mt-1
                        text-white
                        text-[19px]
                        xs:text-[20px]
                        sm:text-[22px]
                        md:text-[24px]
                        font-bold
                        leading-tight
                      ">
                        {showOtp
                          ? "Verify your OTP"
                          : "Welcome back"}
                      </h2>

                    </div>

                    <div className="
                      w-9
                      h-9
                      xs:w-10
                      xs:h-10
                      sm:w-11
                      sm:h-11
                      rounded-full
                      bg-white/10
                      border
                      border-white/15
                      flex
                      items-center
                      justify-center
                      shrink-0
                    ">

                      <span className="
                        text-white
                        text-[17px]
                        sm:text-[20px]
                      ">
                        {showOtp ? "✓" : "→"}
                      </span>

                    </div>

                  </div>

                  <p className="
                    mt-2
                    text-white/75
                    text-[9px]
                    xs:text-[10px]
                    sm:text-[11px]
                    md:text-[12px]
                    leading-5
                  ">
                    {showOtp
                      ? "Enter the six-digit verification code sent to your email."
                      : "Login securely without a password."}
                  </p>

                </div>

                {/* CARD BODY */}

                <div className="
                  px-4
                  xs:px-5
                  sm:px-6
                  md:px-7
                  py-6
                  xs:py-7
                  sm:py-8
                ">

                  {/* ERROR */}

                  {error && (
                    <div className="
                      mb-4
                      rounded-[9px]
                      bg-[#FCEDEA]
                      border
                      border-[#F1C8C1]
                      px-3
                      sm:px-4
                      py-2.5
                      sm:py-3
                      text-[10px]
                      sm:text-[11px]
                      md:text-[12px]
                      text-[#B63D2E]
                    ">
                      {error}
                    </div>
                  )}

                  {/* =================================================
                      EMAIL
                  ================================================= */}

                  {!showOtp && (
                    <>

                      <label
                        htmlFor="loginEmail"
                        className="
                          block
                          mb-2
                          text-[10px]
                          sm:text-[11px]
                          font-semibold
                          text-[#625C7D]
                        "
                      >
                        Registered email address
                      </label>

                      <div className="relative">

                        <span className="
                          absolute
                          left-3.5
                          sm:left-4
                          top-1/2
                          -translate-y-1/2
                          text-[#8D87A0]
                          text-[14px]
                          sm:text-[15px]
                        ">
                          @
                        </span>

                        <input
                          id="loginEmail"
                          type="email"
                          value={email}
                          placeholder="Enter your email address"
                          autoComplete="email"
                          onChange={(e) => {
                            setEmail(
                              e.target.value
                            );
                            setError("");
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === "Enter"
                            ) {
                              e.preventDefault();
                              handleSendOtp();
                            }
                          }}
                          className="
                            w-full
                            h-[47px]
                            xs:h-[49px]
                            sm:h-[50px]
                            rounded-[10px]
                            sm:rounded-[11px]
                            border
                            border-[#DDD5C7]
                            bg-[#FFFDF9]
                            pl-9
                            sm:pl-10
                            pr-3
                            sm:pr-4
                            text-[12px]
                            sm:text-[13px]
                            text-[#17144B]
                            placeholder:text-[#AAA4B2]
                            outline-none
                            transition
                            focus:border-[#4035C9]
                            focus:ring-4
                            focus:ring-[#4035C9]/10
                          "
                        />

                      </div>

                      <button
                        type="button"
                        onClick={handleSendOtp}
                        disabled={loading}
                        className="
                          w-full
                          h-[47px]
                          xs:h-[49px]
                          sm:h-[50px]
                          mt-4
                          sm:mt-5
                          rounded-full
                          bg-[#17144B]
                          text-white
                          text-[12px]
                          sm:text-[13px]
                          font-bold
                          hover:bg-[#27225E]
                          active:scale-[0.99]
                          transition
                          disabled:opacity-60
                          disabled:cursor-not-allowed
                        "
                      >
                        {loading
                          ? "Sending OTP..."
                          : "Send OTP"}
                      </button>

                      <p className="
                        mt-4
                        sm:mt-5
                        text-center
                        text-[10px]
                        sm:text-[11px]
                        text-[#7B748C]
                      ">
                        New to InstaED?{" "}

                        <button
                          type="button"
                          onClick={() =>
                            navigate("/register")
                          }
                          className="
                            font-semibold
                            text-[#4035C9]
                            hover:underline
                          "
                        >
                          Create an account
                        </button>

                      </p>

                    </>
                  )}

                  {/* =================================================
                      OTP
                  ================================================= */}

                  {showOtp && (
                    <>

                      {/* EMAIL */}

                      <div className="
                        flex
                        items-start
                        justify-between
                        gap-3
                        mb-5
                      ">

                        <div className="min-w-0">

                          <p className="
                            text-[9px]
                            sm:text-[10px]
                            md:text-[11px]
                            text-[#7B748C]
                          ">
                            OTP sent to
                          </p>

                          <p className="
                            mt-1
                            text-[11px]
                            sm:text-[12px]
                            md:text-[13px]
                            font-semibold
                            text-[#17144B]
                            break-all
                          ">
                            {email}
                          </p>

                        </div>

                        <button
                          type="button"
                          onClick={handleChangeEmail}
                          className="
                            text-[10px]
                            sm:text-[11px]
                            font-semibold
                            text-[#4035C9]
                            hover:underline
                            shrink-0
                          "
                        >
                          Change
                        </button>

                      </div>

                      {/* OTP INPUTS */}

                      <div
                        className="
                          w-full
                          flex
                          justify-center
                          gap-1.5
                          xs:gap-2
                          sm:gap-2.5
                          md:gap-3
                        "
                        onPaste={handleOtpPaste}
                      >

                        {otp.map(
                          (digit, index) => (
                            <input
                              key={index}
                              ref={(element) => {
                                otpRefs.current[
                                  index
                                ] = element;
                              }}
                              id={`otp-${index}`}
                              type="text"
                              inputMode="numeric"
                              autoComplete={
                                index === 0
                                  ? "one-time-code"
                                  : "off"
                              }
                              maxLength={1}
                              value={digit}
                              onChange={(e) =>
                                handleOtpChange(
                                  e.target.value,
                                  index
                                )
                              }
                              onKeyDown={(e) =>
                                handleKeyDown(
                                  e,
                                  index
                                )
                              }
                              className="
                                w-[38px]
                                h-[46px]
                                xs:w-[40px]
                                xs:h-[48px]
                                sm:w-[44px]
                                sm:h-[51px]
                                md:w-[48px]
                                md:h-[54px]
                                rounded-[9px]
                                sm:rounded-[10px]
                                border
                                border-[#DDD5C7]
                                bg-[#FFFDF9]
                                text-center
                                text-[18px]
                                sm:text-[20px]
                                font-bold
                                text-[#17144B]
                                outline-none
                                transition
                                focus:border-[#4035C9]
                                focus:ring-4
                                focus:ring-[#4035C9]/10
                              "
                            />
                          )
                        )}

                      </div>

                      {/* INFO */}

                      <p className="
                        mt-4
                        sm:mt-5
                        text-center
                        text-[10px]
                        sm:text-[11px]
                        leading-5
                        text-[#777083]
                      ">
                        Enter the 6-digit OTP
                        received on your
                        registered email.
                      </p>

                      {/* VERIFY */}

                      <button
                        type="button"
                        disabled={
                          loading ||
                          otp.some(
                            (digit) => !digit
                          )
                        }
                        onClick={() =>
                          handleLogin(
                            otp.join("")
                          )
                        }
                        className="
                          w-full
                          h-[47px]
                          xs:h-[49px]
                          sm:h-[50px]
                          mt-4
                          sm:mt-5
                          rounded-full
                          bg-[#17144B]
                          text-white
                          text-[12px]
                          sm:text-[13px]
                          font-bold
                          hover:bg-[#27225E]
                          active:scale-[0.99]
                          transition
                          disabled:opacity-40
                          disabled:cursor-not-allowed
                        "
                      >
                        {loading
                          ? "Verifying..."
                          : "Verify & Login"}
                      </button>

                      {/* RESEND */}

                      <div className="
                        mt-4
                        sm:mt-5
                        text-center
                      ">

                        {timer > 0 ? (
                          <p className="
                            text-[10px]
                            sm:text-[11px]
                            text-[#777083]
                          ">
                            Didn't receive the code?{" "}

                            <span className="font-semibold text-[#4035C9]">
                              Resend in {timer}s
                            </span>
                          </p>
                        ) : (
                          <p className="
                            text-[10px]
                            sm:text-[11px]
                            text-[#777083]
                          ">
                            Didn't receive the code?{" "}

                            <button
                              type="button"
                              onClick={handleResendOtp}
                              className="
                                font-semibold
                                text-[#4035C9]
                                hover:underline
                              "
                            >
                              Resend OTP
                            </button>
                          </p>
                        )}

                      </div>

                    </>
                  )}

                </div>

              </div>

              {/* SECURITY */}

              <div className="
                mt-3
                sm:mt-4
                flex
                items-center
                justify-center
                gap-1.5
                sm:gap-2
                text-[9px]
                sm:text-[10px]
                text-[#8B8497]
              ">

                <span className="text-[#4035C9]">
                  ✓
                </span>

                Secure OTP authentication

              </div>

            </div>

          </div>

        </section>

        {/* =====================================================
            FOOTER
        ===================================================== */}

        <footer className="
          w-full
          max-w-[1280px]
          mx-auto
          px-4
          sm:px-7
          md:px-8
          lg:px-10
          pb-4
          sm:pb-5
        ">

          <div className="
            border-t
            border-[#E2D9CA]
            pt-3
            sm:pt-4
            flex
            flex-wrap
            items-center
            justify-center
            gap-x-3
            sm:gap-x-4
            gap-y-1.5
            text-[9px]
            sm:text-[10px]
            md:text-[11px]
            text-[#8C8597]
          ">

            <span>
              © 2026 InstaED
            </span>

            <span>|</span>

            <button
              type="button"
              onClick={() =>
                navigate("/terms-condition")
              }
              className="hover:text-[#4035C9] transition"
            >
              Terms of Use
            </button>

            <span>|</span>

            <button
              type="button"
              onClick={() =>
                navigate("/policy")
              }
              className="hover:text-[#4035C9] transition"
            >
              Privacy Policy
            </button>

          </div>

        </footer>

      </main>
    </>
  );
};

// =============================================================
// FEATURE COMPONENT
// =============================================================

const Feature = ({
  number,
  title,
  text,
}) => {
  return (
    <div className="
      flex
      items-start
      gap-3
      sm:gap-4
      bg-white/70
      border
      border-[#E6DED1]
      rounded-[12px]
      px-3
      sm:px-4
      py-3
      sm:py-3.5
    ">

      <div className="
        w-7
        h-7
        sm:w-8
        sm:h-8
        md:w-9
        md:h-9
        rounded-full
        bg-[#E8E5FA]
        text-[#4035C9]
        flex
        items-center
        justify-center
        text-[9px]
        sm:text-[10px]
        font-bold
        shrink-0
      ">
        {number}
      </div>

      <div className="min-w-0">

        <h3 className="
          text-[11px]
          sm:text-[12px]
          md:text-[13px]
          font-bold
          text-[#17144B]
        ">
          {title}
        </h3>

        <p className="
          mt-0.5
          sm:mt-1
          text-[9px]
          sm:text-[10px]
          md:text-[11px]
          leading-4
          sm:leading-5
          text-[#777083]
        ">
          {text}
        </p>

      </div>

    </div>
  );
};

export default LoginWithOtp;